import type { Demande } from '../../types';
import { infoBandeau } from './parcours';
import { etatFrise, phraseCarte, quiAgit } from './elementsJour';

/**
 * « Où en est cette demande ? » dans la liste, sans ouvrir la fiche : les mêmes étapes que la frise de la fiche, en petits
 * traits (faites, en cours, à venir), et UNE phrase — le nom de l'étape et qui doit agir. Une demande hors parcours normal
 * (urgence, annulée, fusionnée…) montre sa phrase, sans frise, comme sur la fiche. Les traits sont décoratifs pour un lecteur
 * d'écran : la phrase dit tout (« Étape 3 sur 7 · Validations »). Le calendrier « Mes demandes » utilise les mêmes règles
 * (elementsJour.ts : etatFrise, quiAgit) pour que la liste et le calendrier disent la même chose.
 */
export function MiniFrise({ demande, peutGerer }: { demande: Demande; peutGerer: boolean }) {
  // La date de la séance fait passer « Atelier » (6) à « Retour » (7) : la même règle que la frise de la fiche.
  const frise = etatFrise(demande.statut, demande.date_atelier);
  if (frise.phase == null) {
    // Hors parcours : la personne lit une phrase qui lui est destinée (jamais « Brouillon classé sans suite » ni « cascade »).
    return <span className="frise-mini-phrase">{peutGerer ? infoBandeau(demande.statut, demande.date_atelier).titre : phraseCarte(demande)}</span>;
  }
  const acteur = quiAgit(demande, peutGerer);
  return (
    <div className="frise-mini">
      <div className="frise-mini-points" aria-hidden="true">
        {frise.traits.map((etat, i) => <i key={i} className={etat} />)}
      </div>
      <span className="frise-mini-phrase">
        {frise.termine
          ? <b>Remplacement effectué</b>
          : <>Étape {frise.numero} sur {frise.total} · <b>{frise.nom}</b>{acteur ? ` : ${acteur}` : ''}</>}
      </span>
    </div>
  );
}
